export default __webpack_public_path__ + "static/media/step_A@2x.7789e79d.png";